<div class="direct-debit" *ngIf="contents">
    <div class="main-title" [ngStyle]="{ background: bgImg }">
        <h1>{{ contents.homePage.header }}</h1>
        <!-- <h2>{{ contents.homePage.subHeader }}</h2> -->
    </div>
    <div class="content">
        <div class="advantage-wrapper">
            <div class="advantage" *ngFor="let cube of contents.homePage.cubes">
                <img [src]="cube.imageLink" alt="" class="icon" [ngClass]="cube.class" />
                <span class="text">{{ cube.text }}</span>
            </div>
        </div>
        <div class="which-card">
            <div class="title-wrapper">
                <h2>
                    {{ contents.homePage.textTitle }}
                </h2>
                <span class="card-limit">{{ contents.homePage.textSubTitle }}</span>
            </div>
            <div class="pick-card">
                <app-card-autocomplete
                    [userCards]="userCards"
                    (select)="onSelect($event)"
                    [displayBenefit]="displayBenefit"
                ></app-card-autocomplete>
            </div>
        </div>
        <div *ngIf="false" class="what-you-get">
            <h3>רוצים לדעת כמה תוכלו לקבל?</h3>
            <p>
                יצרנו בשבילכם מחשבון שבעזרתו תוכלו לחשב מהן גובהה הוראות הקבע החודשיות שלכם ולגלות אילו פינוקים והטבות
                תוכלו לקבל בהעברת הוראות הקבע לכרטיסי M_A_X
            </p>
            <a class="brand-button solid-button-white" title=""><span>כמה אני יכול להרוויח?</span></a>
        </div>

        <div class="terms">
            <p>
                {{ contents.homePage.asterix }}
            </p>
        </div>
    </div>
</div>
